import { MENU_LIST, SCROLL_Y, ADD_CACHED_INCLUDE, REMOVE_CACHED_INCLUDE, ADD_CACHED_EXCLUDE, REMOVE_CACHED_EXCLUDE, CHANGE_NETWORK } from './const'
export default {
    [MENU_LIST] (state, payload) {
        state.menus = payload
    },
    [SCROLL_Y] (state, recruitScrollY) {
        state.recruitScrollY = recruitScrollY
    },
    [ADD_CACHED_INCLUDE] (state, payload) {
        state.cachedInclude.push(payload)
    },
    [REMOVE_CACHED_INCLUDE] (state, payload) {
        state.cachedInclude = state.cachedInclude.filter(item => item !== payload)
    },
    [ADD_CACHED_EXCLUDE] (state, payload) {
        state.cachedExclude.push(payload)
    },
    [REMOVE_CACHED_EXCLUDE] (state, payload) {
        state.cachedExclude = state.cachedExclude.filter(item => item !== payload)
    },
    [CHANGE_NETWORK] (state, payload) {
        state.network = payload
    }
}
